export function GetMockLookupRead() {
  return {
    id: 1,
    lookupTypeId: 1,
    description: "Proceedable",
    order: 0,
  };
}
